import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { ServiceHelpersService } from '../../_helpers/service-helpers.service';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {

  constructor(
    private http: HttpClient,
    private serviceHelpers: ServiceHelpersService,
    private location: Location
  ) { }

  getClaimsDetails(email): Observable<any> {
    const url = `${environment.backend_server_url_account}/claims/${email}`;
    return this.http.get(url);
  }
  getClaimDocuments(claimId, policyNumber): Observable<any> {
    const isLegacy = policyNumber.length !== 10;
    const url = `${environment.backend_server_url_account}/${policyNumber}/${claimId}/documents?isLegacy=${isLegacy}`;
    return this.http.get(url);
  }
  sendExlClaimReport(report) {
    const url = `${environment.backend_server_url}/claims-livo/exl-report-claim`;
    return this.http.post(url, report);
  }
  reportClaim(policy): Observable<string> {
    const url = `${environment.backend_server_url_claims}/report-claim?policyNumber=${policy.policynumber.policyNumber}&name=${policy.insured[0].lastName}&zipCode=${policy.mailingAddress.zipCode.code}&policyType=${policy.policyType}`;
    return this.http.get(url, { responseType: 'text' });
  }
  uploadDocuments(claimId, type, formData, policyNumber): Observable<any> {
    let path, isLegacy;
    if (policyNumber.length === 10) {
      path = 'GW';
      isLegacy = false;
    } else {
      path = 'AS400';
      isLegacy = true;
    }
    const url = `${environment.backend_server_url_account}/${path}/${claimId}/documents?isLegacy=${isLegacy}&type=${type}`;
    return this.http.post(url, formData).pipe(
      map((response) => response),
      catchError((err) => of(err))
    );
  }
  setClaimURL(policy) {
    localStorage.removeItem('cD');
    localStorage.setItem(
      'cD',
      btoa(
        `${environment.backend_server_url_claims}/report-claim?policyNumber=${policy.policynumber.policyNumber}&name=${policy.insured[0].lastName}&zipCode=${policy.mailingAddress.zipCode.code}&policyType=${policy.policyType}`
      )
    );
  }

  reportAClaim() {
    return this.http.get(atob(localStorage.getItem('cD')), {
      responseType: 'text',
    });
  }

  isCommercialPolicy(policy) {
    return policy?.policynumber?.policyNumber?.length === 6;
  }

  getClaimReportForPolicy(policy) {
    const accountHolder = JSON.parse(localStorage.getItem('accountHolder'));
    const isCommercial = this.isCommercialPolicy(policy);
    return {
      policyNumber: policy?.policynumber?.policyNumber,
      mailingZipCode: policy?.mailingAddress?.zipCode?.code,
      accountHolderFirstName: isCommercial ? '' : accountHolder?.firstName,//user object
      accountHolderLastName: isCommercial ? '' : accountHolder?.lastName,//user object
      accountHolderBusinessName: isCommercial ? accountHolder?.firstName : '', //user object first name only
      accountEmail: accountHolder?.email?.email, //user object
      policyType: isCommercial ? 'Commercial' : 'Personal',
      lineOfBusiness: policy?.policyType,
      continueClaim: false
    }
  }

  getBlankClaimReport() {
    return {
      policyNumber: '',
      mailingZipCode: '',
      accountHolderFirstName: '',
      accountHolderLastName: '',
      accountHolderBusinessName: '',
      accountEmail: '',
      policyType: '',
      lineOfBusiness: '',
      continueClaim: true
    }
  }

  goBack() {
    if (Capacitor.isNativePlatform()) {
      this.location.back();
    }
  }

  openInNewTab(url) {
    if (Capacitor.isNativePlatform()) {
      Browser.open({ url });
    } else {
      window.open(url);
    }
    this.goBack();
  }

}
